import {memo, useEffect, useMemo, useState} from "react";
import {Alert, Button, Card, Col, Divider, Row, Switch} from "antd";
import SanKey from "../Charts/SanKey";
import SkillsBarChart from "../Charts/SkillsBarChart";
import GrowthRateChart from "../Charts/GrowthRateChart";
import IndustryChart from "../Charts/IndustryChart";
import useSWR from "swr";
import UniversityChart from "../Charts/UniversityChart";
import ColumnCompareAbleChart from "../Charts/ColumnCompareChart";
import CompareRadarChart from "../Charts/CompareRadarChart";
import pluck from "../Helpers/ArrayHelper";
import CommonCareerChart from "../Charts/CommonCareerChart";

const GroupShowcase = memo(({selectedGroup}) => {

    const subGroupQuery = useMemo(() => `/groups/${selectedGroup?.id}`, [selectedGroup]);
    const { data: subGroups } = useSWR(selectedGroup ? subGroupQuery : null);

    const [isSankeySelectedJobPosts, setIsSankeySelectedJobPosts] = useState(false);
    const [isCompareChartSelectedJobPosts, setIsCompareChartSelectedJobPosts] = useState(false);

    // note: subGroups => Group Data with subgroups

    // useEffect(() => {
    //     console.log(selectedGroup)
    // }, [selectedGroup])

    return <>
        {
            (!subGroups?.thailand_skills_overview?.length > 0 ||
                !subGroups?.thailand_common_careers_overview?.length > 0 ||
                !subGroups?.thailand_common_skills_overview?.length > 0 ||
                !subGroups?.thailand_skills_growth_overview?.length > 0 ||
                !subGroups?.thailand_industries_overview?.length > 0 ||
                !subGroups?.thailand_universities_overview?.length > 0) &&
            <Alert
                type='warning'
                message='ไม่พบข้อมูลกลุ่มตัวอย่างของตำแหน่งงานในประเทศไทย'
                description={`ไม่พบบางข้อมูลของกลุ่มตัวอย่างเกี่ยวกับกลุ่มงาน ${subGroups?.name} ในประเทศไทย`}
                style={{ marginTop: '12px', marginBottom: '12px' }}
                showIcon
            />
        }
        <h1>
            กลุ่ม { selectedGroup?.name }
        </h1>
        <Row justify={'center'} gutter={[8, 6]}>
            <Col span={24} md={12} lg={6}>
                <Card title="จำนวนกลุ่มตัวอย่างผู้ที่ประกอบอาชีพในกลุ่มนี้" style={{ textAlign: 'center' }} bodyStyle={{ padding: '4px' }} headStyle={{ whiteSpace: 'none' }}>
                    <span style={{ fontSize: '32px' }}>
                        { subGroups?.counts?.sample.toLocaleString() ?? '-' }
                    </span> คน
                </Card>
            </Col>
            <Col span={24} md={12} lg={6}>
                <Card title="จำนวนกลุ่มตัวอย่างผู้ที่ประกอบอาชีพในกลุ่มนี้ (ไทย)" style={{ textAlign: 'center' }} bodyStyle={{ padding: '4px' }}>
                    <span style={{ fontSize: '32px' }}>
                        { subGroups?.counts?.sample_th.toLocaleString() ?? '-' }
                    </span> คน
                </Card>
            </Col>
            <Col span={24} md={12} lg={6}>
                <Card title="จำนวนประกาศรับสมัครงาน" style={{ textAlign: 'center' }} bodyStyle={{ padding: '4px' }}>
                    <span style={{ fontSize: '32px' }}>
                        { subGroups?.counts?.job_posts_sample.toLocaleString() ?? '-' }
                    </span> ประกาศ
                </Card>
            </Col>
            <Col span={24} md={12} lg={6}>
                <Card title="จำนวนประกาศรับสมัครงาน (ไทย)" style={{ textAlign: 'center' }} bodyStyle={{ padding: '4px' }}>
                    <span style={{ fontSize: '32px' }}>
                        { subGroups?.counts?.job_posts_sample_th.toLocaleString() ?? '-' }
                    </span> ประกาศ
                </Card>
            </Col>
        </Row>
        <h2>
            ภาพรวมอาชีพ
        </h2>
        <Row gutter={8}>
            <Col span={24}>
                <Alert
                    message="คำอธิบาย"
                    description={`กราฟแท่งแสดง จำนวนคนที่ประกอบอาชีพนั้น ๆ ที่ได้ดึงมาจากฐานข้อมูล โดยดึงข้อมูลมาจากผู้ที่ทำงานอาชีพนั้นๆ ${subGroups?.thailand_common_careers_overview.length > 0 ? 'ทั้งจากทั่วโลก และประเทศไทย' : 'จากทั่วโลก'} เพื่อนำข้อมูลจากบุคคลเหล่านี้ไปวิเคราะห์ต่อ ในส่วนถัดไป`}
                    type="info"
                    showIcon
                />
            </Col>
            <Col span={24} lg={subGroups?.thailand_common_careers_overview.length ? 12 : 24}>
                <Card
                    title="จำนวนคนของกลุ่มตัวอย่างที่ประกอบอาชีพนี้ (ทั่วโลก)"
                >
                    <CommonCareerChart data={subGroups?.common_careers_overview} />
                </Card>
            </Col>
            {
                subGroups?.thailand_common_careers_overview.length > 0 &&
                    <>
                        <Col span={24} lg={12}>
                            <Card
                                title="จำนวนคนของกลุ่มตัวอย่างที่ประกอบอาชีพนี้ (ประเทศไทย)"
                            >
                                <CommonCareerChart data={subGroups?.thailand_common_careers_overview} />
                            </Card>
                        </Col>
                    </>
            }
        </Row>
        <Divider/>
        <h2>
            ภาพรวม Skill
        </h2>
        <Alert
            message="คำอธิบาย"
            description={`กราฟ Sankey Diagram แสดงความสัมพันธ์ระหว่างทักษะที่ต้องมีกับกลุ่มอาชีพ โดยที่ด้านซ้ายมือแสดงชื่อทักษะ และ ด้านขวามือแสดงรายชื่อกลุ่มย่อยของอาชีพ เส้นกราฟที่โยงจากซ้ายมือไปขวามือ จะแสดงว่าแต่ละกลุ่มย่อยของอาชีพนั้นต้องการทักษะอะไรบ้าง`}
            type="info"
            showIcon
        />
        <Row gutter={8}>
            <Col span={24}>
                <Card>
                    <Row justify={'space-between'}>
                        <Col>
                            <h2>
                                Skill
                            </h2>
                        </Col>
                        <Col>
                            <h2>
                                กลุ่มย่อย
                            </h2>
                        </Col>
                    </Row>
                    <SanKey data={isSankeySelectedJobPosts ? subGroups?.sub_groups_job_posts_overview : subGroups?.skills_overview} source={'skill'} target={'group'} weight={'amount'} />

                    {
                        subGroups?.sub_groups_job_posts_overview?.length > 0 ? <>
                            <Row justify={'end'} style={{marginTop: '6px'}}>
                                <Col>
                                    ที่มาข้อมูล : <Switch
                                    checkedChildren={'ประกาศรับสมัครงาน'}
                                    unCheckedChildren={'คนในตำแหน่งงาน'}
                                    defaultChecked={isSankeySelectedJobPosts}
                                    onChange={(isChecked) => {
                                        setIsSankeySelectedJobPosts(isChecked)
                                    }}
                                />
                                </Col>
                            </Row>
                        </> : ''
                    }
                </Card>
            </Col>
        </Row>
        <Divider/>
        <h2>
            เปรียบเทียบ Skill
        </h2>
        <Alert
            message="คำอธิบาย"
            description={`จากจำนวนคนที่ประกอบอาชีพนั้น ๆ ตามที่กล่าวในตอนต้น  พบว่าบุคคล 1 คน อาจจะมีได้หลายทักษะ จึงนำข้อมูลของทุกคนมารวบรวมว่าแต่ละคนมีทักษะอะไรบ้าง และแสดงผลเป็นกราฟแท่ง เพื่อแสดงจำนวนคนที่มีทักษะนั้นๆ โดยชื่อด้านซ้ายมือคือชื่อทักษะ และกราฟแท่งแสดงจำนวนคนที่มีทักษะนั้นๆ`}
            type="info"
            showIcon
        />
        <Row gutter={8}>
            <Col span={24} lg={subGroups?.thailand_common_skills_overview.length > 0 ? 12 : 24}>
                <Card
                    title={`จำนวนคนที่มีทักษะด้านต่าง ๆ จากกลุ่ม ${selectedGroup?.name} (ทั่วโลก)`}
                >
                    <SkillsBarChart
                        data={subGroups?.common_skills_overview}
                        xAxis={'skill'}
                        yAxis={'amount'}
                        customConfig={{
                            meta: {amount: {alias: 'จำนวนคน', formatter: (v) => `${v} คน`}},
                            color: '#164176'
                        }}
                    />
                </Card>
            </Col>
            {
                subGroups?.thailand_common_skills_overview.length > 0 && <>
                    <Col span={24} lg={12}>
                        <Card
                            title={`จำนวนคนที่มีทักษะด้านต่าง ๆ จากกลุ่ม ${selectedGroup?.name} (ประเทศไทย)`}
                        >
                            <SkillsBarChart
                                data={subGroups?.thailand_common_skills_overview}
                                xAxis={'skill'}
                                yAxis={'amount'}
                                customConfig={{
                                    meta: {
                                        amount: { alias: 'จำนวนคน', formatter: (v) => `${v} คน` },
                                    },
                                    color: '#ff9318'
                                }}
                            />
                        </Card>
                    </Col>
                </>
            }
        </Row>
        {
            subGroups?.thailand_job_posts_overview.length ? <>
                <Row gutter={8}>
                    <Col span={24} lg={subGroups?.thailand_job_posts_overview.length > 0 ? 12 : 24}>
                        <Card
                            title={`จำนวนประกาศรับสมัครงานที่ต้องการทักษะต่าง ๆ (ทั่วโลก)`}
                        >
                            <SkillsBarChart
                                data={subGroups?.job_posts_overview}
                                xAxis={'skill'}
                                yAxis={'amount'}
                                customConfig={{
                                    meta: {amount: {alias: 'จำนวนคน', formatter: (v) => `${v} คน`}},
                                    color: '#164176'
                                }}
                            />
                        </Card>
                    </Col>
                    {
                        subGroups?.thailand_job_posts_overview.length > 0 && <>
                            <Col span={24} lg={12}>
                                <Card
                                    title={`จำนวนประกาศรับสมัครงานที่ต้องการทักษะต่าง ๆ (ประเทศไทย)`}
                                >
                                    <SkillsBarChart
                                        data={subGroups?.thailand_job_posts_overview}
                                        xAxis={'skill'}
                                        yAxis={'amount'}
                                        customConfig={{
                                            meta: {
                                                amount: { alias: 'จำนวนคน', formatter: (v) => `${v} คน` },
                                            },
                                            color: '#ff9318'
                                        }}
                                    />
                                </Card>
                            </Col>
                        </>
                    }
                </Row>
            </> : null
        }
        <Divider/>
        {
            subGroups?.thailand_common_skills_overview.length > 0 && <>
                <h3>
                    { isCompareChartSelectedJobPosts ? `เปรียบเทียบอัตราส่วนทักษะต่าง ๆ ที่อยู่ในประกาศรับสมัครงาน ในกลุ่ม ${selectedGroup?.name} ระหว่างทั่วโลก กับ ประเทศไทย`
                        : `เปรียบเทียบอัตราส่วนผู้ที่มีทักษะต่าง ๆ ในกลุ่ม ${selectedGroup?.name} ระหว่างทั่วโลก กับ ประเทศไทย` }
                </h3>

                {
                    subGroups?.job_posts_overview?.length > 0 ? <>
                        <Row justify={'end'} style={{marginTop: '6px', marginBottom: '6px'}}>
                            <Col>
                                ที่มาข้อมูล : <Switch
                                checkedChildren={'ประกาศรับสมัครงาน'}
                                unCheckedChildren={'คนในตำแหน่งงาน'}
                                defaultChecked={isCompareChartSelectedJobPosts}
                                onChange={(isChecked) => {
                                    setIsCompareChartSelectedJobPosts(isChecked)
                                }}
                            />
                            </Col>
                        </Row>
                    </> : ''
                }
                <Alert
                    message="คำอธิบาย"
                    description={`จากจำนวนคนที่มีทักษะนั้นๆ ตามที่กล่าวมาข้างต้น จึงได้นำมาเทียบกับจำนวนทั้งหมดเพื่อหาเป็นสัดส่วน (%)  ดังนั้นกราฟแท่งนี้ จึงเป็นการเปรียบเทียบว่า ในจำนวนบุคคลที่ประกอบอาชีพในกลุ่มนั้น มีทักษะอะไรบ้างอย่างละกี่เปอร์เซ็น (%) โดยที่แกนนอนแสดงชื่อทักษะ และแกนตั้งแสดงจำนวนเปอร์เซ็น (%)  ซึ่งกราฟสีน้ำเงินเป็นการเปรียบเทียบของกลุ่มคนระดับโลก ในขณะที่กราฟสีส้มเป็นการเปรียบเทียบของกลุ่มคนไทย`}
                    type="info"
                    showIcon
                />
                <Row>
                    <Col span={24}>
                        <Card
                        >
                            <ColumnCompareAbleChart
                                data={[
                                    ...(isCompareChartSelectedJobPosts ? subGroups?.job_posts_overview : subGroups?.common_skills_overview).map((skill) => {
                                        return {
                                            skill: skill.skill,
                                            amount: skill.percentage,
                                            scope: 'ทั่วโลก'
                                        };
                                    }),
                                    ...(isCompareChartSelectedJobPosts ? subGroups?.thailand_job_posts_overview : subGroups?.thailand_common_skills_overview).map((skill) => {
                                        return {
                                            skill: skill.skill,
                                            amount: skill.percentage,
                                            scope: 'ประเทศไทย'
                                        };
                                    }),
                                ]}
                                xAxis={'skill'}
                                yAxis={'amount'}
                                customConfig={{
                                    // label: {
                                    //     content: (_ref) => {
                                    //         return `${_ref.amount} %`
                                    //     }
                                    // },
                                    seriesField: 'scope',
                                    meta: {
                                        amount: { alias: 'ร้อยละ', formatter: (v) => `${v}%` }
                                    },
                                    isGroup: true,
                                    // isPercent: true,
                                    scrollbar: { type: 'horizontal' },
                                    color: ['#164176', '#dd720b']
                                }}
                            />
                        </Card>
                    </Col>
                </Row>
                <h3>
                    { isCompareChartSelectedJobPosts ? 'Radar chart เพื่อเปรียบเทียบอัตราส่วนร้อยละของความต้องการทักษะต่าง ๆ ในประกาศรับสมัครงาน ของกลุ่มคนระดับโลก เทียบกับกลุ่มคนระดับประเทศ'
                        : 'Radar chart เพื่อเปรียบเทียบอัตราส่วนร้อยละ ของคนที่มีทักษะต่าง ๆ ของกลุ่มคนระดับโลก เทียบกับกลุ่มคนระดับประเทศ' }
                </h3>
                <Row>
                    <Col span={24} lg={24}>
                        <Card>
                            <CompareRadarChart
                                data={
                                    (() => {
                                        let all_skills = isCompareChartSelectedJobPosts ?
                                            [...new Set(pluck([...subGroups?.job_posts_overview, ...subGroups?.thailand_job_posts_overview], 'skill'))]
                                            : [...new Set(pluck([...subGroups?.common_skills_overview, ...subGroups?.thailand_common_skills_overview], 'skill'))]
                                        let plot_data = [];
                                        all_skills.forEach((skill) => {
                                            let a = (isCompareChartSelectedJobPosts ? subGroups?.job_posts_overview : subGroups?.common_skills_overview).filter(s_skill => s_skill.skill === skill)
                                            let b = (isCompareChartSelectedJobPosts ? subGroups?.thailand_job_posts_overview : subGroups?.thailand_common_skills_overview).filter(s_skill => s_skill.skill === skill)
                                            if(a.length > 0 && b.length > 0) {
                                                a = a[0];
                                                b = b[0];
                                                plot_data.push({
                                                    skill: a.skill,
                                                    percentage: a.percentage,
                                                    scope: 'ทั่วโลก'
                                                });
                                                plot_data.push({
                                                    skill: b.skill,
                                                    percentage: b.percentage,
                                                    scope: 'ประเทศไทย'
                                                });
                                            }
                                        })
                                        return plot_data.splice(0, 20)
                                    })()
                                }
                            />
                        </Card>
                    </Col>
                </Row>
            </>
        }
        <Divider/>
        <h1>
            ข้อมูลเพิ่มเติม
        </h1>
        <h2>
            ทั่วโลก
        </h2>
        <Row gutter={8}>
            <Col span={24} lg={subGroups?.industries_job_posts_overview?.length > 0 ? 24 : 12}>
                <Card
                    title={`ทักษะในกลุ่ม ${selectedGroup?.name} ที่มีอัตราการเพิ่มมากที่สุดในช่วง 1 ปี`}
                >
                    <GrowthRateChart
                        data={subGroups?.skills_growth_overview}
                    />
                </Card>
            </Col>
            <Col span={24} lg={12}>
                <Card
                    title={`กลุ่มอุตสาหกรรมที่มีตำแหน่งงานมากที่สุดในกลุ่ม ${selectedGroup?.name}`}
                >
                    <IndustryChart data={subGroups?.industries_overview} />
                </Card>
            </Col>
            {
                subGroups?.industries_job_posts_overview?.length > 0 ?
                <>
                    <Col span={24} lg={12}>
                        <Card
                            title={`กลุ่มอุตสาหกรรมที่มีประกาศรับสมัครงานในตำแหน่ง ${selectedGroup?.name}`}
                        >
                            <IndustryChart data={subGroups?.industries_job_posts_overview} />
                        </Card>
                    </Col>
                </> : null
            }
        </Row>
        <Divider/>
        {
            (!!subGroups?.thailand_skills_growth_overview.length ||
                !!subGroups?.thailand_industries_overview.length ||
                !!subGroups?.thailand_universities_overview.length) && <>

                <h2>
                    ประเทศไทย
                </h2>
                <Row gutter={8}>
                    <Col span={24} lg={12}>
                        <Card
                            title={`ทักษะในกลุ่ม ${selectedGroup?.name} ที่มีอัตราการเพิ่มมากที่สุดในช่วง 1 ปี`}
                        >
                            <GrowthRateChart
                                data={subGroups?.thailand_skills_growth_overview}
                            />
                        </Card>
                    </Col>
                    <Col span={24} lg={12}>
                        <Card
                            title={`กลุ่มอุตสาหกรรมที่มีตำแหน่งงานในกลุ่ม ${selectedGroup?.name}`}
                        >
                            <IndustryChart
                                data={subGroups?.thailand_industries_overview}
                            />
                        </Card>
                    </Col>
                </Row>
                <Row style={{ marginTop: '24px' }}>
                    {
                        subGroups?.thailand_industries_job_posts_overview?.length > 0 ?
                            <>
                                <Col span={24} lg={12}>
                                    <Card
                                        title={`กลุ่มอุตสาหกรรมที่มีประกาศรับสมัครงานในตำแหน่ง ${selectedGroup?.name}`}
                                    >
                                        <IndustryChart data={subGroups?.thailand_industries_job_posts_overview} />
                                    </Card>
                                </Col>
                            </> : null
                    }
                    <Col span={subGroups?.thailand_industries_job_posts_overview?.length > 0 ? 12 : 24}>
                        <Card
                            title={`มหาวิทยาลัยที่มีการผลิตบุคลากร เพื่อประกอบอาชีพในกลุ่ม ${selectedGroup?.name}`}
                        >
                            <UniversityChart data={subGroups?.thailand_universities_overview} />
                        </Card>
                    </Col>
                </Row>

            </>
        }
    </>
});

export default GroupShowcase;
